import {makeStyles} from "@material-ui/core/styles";

export const fixedHeaderStyles = makeStyles((theme) => ({
  root: {
      backgroundColor: theme.rootBackground.main,
      ["@media (max-width:812) and (orientation: landscape)"]: { position: 'unset !important' },
  }
}));
